<template>
  <page :basic="true">
    <span slot="header">Knowledge Check</span>

    <template slot="breadcrumbs">
      <b-breadcrumb :items="breadcrumbs"/>
    </template>

    <div v-if="!fetching">
      <table class="table table-borderless kc-table">
        <tr>
          <th>Completed On</th>
          <td>{{ readableDate(model.completed_date_time) }}</td>
        </tr>
        <tr>
          <th>Score</th>
          <td>{{ model.score }}</td>
        </tr>
        <tr>
          <th>Correct Answers</th>
          <td>{{ model.correct_answers }}</td>
        </tr>
        <tr>
          <th>Incorrect Answers</th>
          <td>{{ model.incorrect_answers }}</td>
        </tr>
      </table>

      <div class="questions p-2">
        <h2>Questions</h2>
        <div v-for="(question, idx) in model.questions" :key="question.id" class="question">

          <div class="d-flex p-2 question-content">
            <div class="question-label">
              {{ idx + 1 }}.
            </div>
            <question v-model="question.answer" :question="question"></question>
          </div>
        </div>
      </div>
    </div>

  </page>
</template>

<script>
import { readableDate } from '@/helpers'
import { mapState, mapGetters } from 'vuex'
import page from '../../../templates/page'
import responseApi from '@/api/knowledgechecks/response'
import question from './completed-question'

export default {
  components:{
    question,
    page
  },
  data(){
    return {
      fetching:true,
      model: ''
    }
  },
  computed:{
    ...mapGetters('client', {
      role: 'getCurrentRole'
    }),
    ...mapState('tenants', {
      tenant: 'current'
    }),
    topicId(){
      return this.$route.params.topic
    },
    knowledgecheckId(){
      return this.$route.params.knowledgecheckId
    },
    responseId(){
      return this.$route.params.responseId
    },
    defaultParams(){
      return {
        tenantId: this.tenant.id,
        knowledgecheckId: this.knowledgecheckId,
        responseId: this.responseId
      }
    },
    knowldegecheckView(){
      if(this.topicId){
        return 'client-knowledgecheck'
      }
      else{
        return 'client-component-knowledgecheck'
      }
    },
    breadcrumbs(){
      const crumbs = [
        { text: 'Modules',to: { name: 'client-modules' } },
        { text: 'Components', to: { name: 'client-components' } }
      ]

      if(this.topicId)
      {
        crumbs.push({ text: 'Topics',to: { name: 'client-topics' } })
      }

      crumbs.push({ text: 'Knowledge Check', to: { name: this.knowldegecheckView, params: this.defaultParams } })
      crumbs.push({ text: 'Response', acitve:true })
      return crumbs
    }
  },
  watch:{
    responseId(val){
      this.load()
    }
  },
  mounted(){
    this.load()
  },
  methods:{
    readableDate,
    async load(){
      this.fetching =true
      const response = await responseApi.show(this.defaultParams)
      this.model = response.data.data
      this.model.questions = this.model.questions.sort((a, b) =>  a.order - b.order)
      this.fetching = false
    }
  }
}

</script>

<style lang="scss" scoped>
.kc-table{
  th{
    text-align: left;
    white-space: nowrap;
    width:.33%
  }
}
</style>



// WEBPACK FOOTER //
// src/components/pages/client/knowledge-checks/show.vue